import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30d9f83e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-results" }
const _hoisted_2 = {
  key: 1,
  class: "image-results__error"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 1000 1000",
  class: "danger-text",
  fill: "currentColor",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M500 10C229.8 10 10 229.8 10 500s219.8 490 490 490 490-219.8 490-490S770.2 10 500 10zm0 953.5c-255.6 0-463.5-208-463.5-463.5S244.4 36.5 500 36.5 963.5 244.4 963.5 500 755.6 963.5 500 963.5z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M500 615.9c-13.6 0-24.6-11-24.6-24.6v-309c0-13.6 11-24.6 24.6-24.6 13.6 0 24.6 11 24.6 24.6v308.9c.1 13.6-11 24.7-24.6 24.7zM467 709.4c0 18.2 14.8 33 33 33s33-14.8 33-33-14.8-33-33-33-33 14.8-33 33z" })
], -1))
const _hoisted_4 = {
  key: 2,
  class: "image-results__feedback"
}

import useSearch from '@/composables/useSearch';
import ImageGrid from '@/components/ImageGrid.vue';
import DetectBottom from './ui/DetectBottom.vue';

export type Props = {
  infiniteThreshold?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageResults',
  props: {
    infiniteThreshold: { default: JSON.parse(process.env.VUE_APP_INFINITE_THRESHOLD) }
  },
  setup(__props: any) {

const props = __props;



const {
  nextPage,
  query,
  images,
  error,
  hasImages,
} = useSearch();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(hasImages))
      ? (_openBlock(), _createBlock(DetectBottom, {
          key: 0,
          "root-margin": _ctx.infiniteThreshold,
          onBottom: _unref(nextPage)
        }, {
          default: _withCtx(() => [
            _createVNode(ImageGrid, {
              class: "image-results__grid",
              "empty-message": "No images found",
              images: (_unref(images) as any[])
            }, null, 8, ["images"])
          ]),
          _: 1
        }, 8, ["root-margin", "onBottom"]))
      : (_unref(error) && _unref(query).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", null, _toDisplayString(_unref(error)), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Type in above the name of an image "))
  ]))
}
}

})